import { useEffect } from 'react';

export function usePageReloadOnLocalStorageChange() {
  
  useEffect(() => {
    const clearStorage = (event: StorageEvent) => {
      if (event.key === 'user') {
        if (event.newValue === null) {
          window.location.replace(localStorage.getItem('userLoginUrl')!);
          sessionStorage.removeItem("currentUserId");
          sessionStorage.removeItem("copyMasterButtonModalShow");
          sessionStorage.removeItem("currentSelectedClient");
        } else {
          window.location.reload();
        }
      }
    }
  
    window.addEventListener('storage', clearStorage)
    return () => window.removeEventListener('storage', clearStorage)
  }, [])
  return null;
}